const toRem = (value: number, base = 16): string => `${value / base}rem`

export default toRem
